import { Progress } from 'antd';
import React, { useState } from 'react';
import { MdVisibility } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../store/rootReducer';
import { dealTypes } from '../../../login/utils/Status';
import { DataRoom } from '../../deals/redux/types';
import ExcutedAgreementAndUpdatedFilesModel from '../../Investments/modal/ExecutedAndUpdateFiles';
import { Repayment } from '../../Investments/redux/types';
import { checkRowOfRowPaid, getInterestRateRepayment, showUpdates } from '../../Investments/utils';

const InvestmentRepaymentCard: React.FC = () => {
    const navigate = useNavigate();
    const [openDocument, setOpenDocument] = useState(false);
    const [document, setDoument] = useState<{ updates: DataRoom[]; ExecutedAgreements: DataRoom[] }>({
        updates: [],
        ExecutedAgreements: [],
    });

    const repayment = useSelector((state: RootState) => state.investments.repayment);

    const redirectToDeal = (uuid: string) => {
        return navigate(`/deal/${uuid}`);
    };

    const showExecutedAgreements = (row: Repayment) => {
        let ExecutedAgreements: DataRoom[] = [];
        //if(row && row.investment && row.investment.status && (row.investment.status === investmentStatus.Invested || row.investment.status === investmentStatus.Repaid)) {
        if (row && row.executedAgreements && row.executedAgreements.length > 0) {
            ExecutedAgreements = [...row.executedAgreements];
        }

        //}
        if (ExecutedAgreements.length > 0 || showUpdates(row.updates)) {
            const data: {
                ExecutedAgreements: DataRoom[];
                updates: DataRoom[];
            } = {
                ExecutedAgreements: [],
                updates: [],
            };
            if (ExecutedAgreements.length > 0) {
                data.ExecutedAgreements = ExecutedAgreements;
            }
            if (showUpdates(row.updates)) {
                data.updates = row.updates;
            }

            return (
                <div className="flex items-center text-base justify-center">
                    &nbsp;(Documents{' '}
                    <MdVisibility
                        color="#16365c"
                        className="cursor-pointer ml-1 text-xl md:text-2xl"
                        onClick={() => {
                            setDoument(data);
                            setOpenDocument(true);
                        }}
                    />
                    )
                </div>
            );
        }

        return '-';
    };

    return (
        <div className="mb-4">
            <p className="text-lg pb-4 SourceSansPro-SemiBold">Investment</p>
            <ExcutedAgreementAndUpdatedFilesModel
                updates={document.updates || []}
                executedAgreements={document.ExecutedAgreements || []}
                open={openDocument}
                setOpen={setOpenDocument}
            />
            {repayment && (
                <div className="rounded-md overflow-hidden shadow-lg bg-white h-full relative m-auto ">
                    <div className="px-4 py-4">
                        <p className="text-blue-600" onClick={() => redirectToDeal(repayment.deal.uuid)}>
                            {repayment.deal.title}
                        </p>
                        <div className="flex justify-between items-center">
                            <p className="text-xs">
                                {repayment.issuer?.name}&nbsp;&nbsp;{repayment.issuer?.country}
                            </p>
                            <p className="text-xs">
                                {repayment.deal.instrumentType}
                                {`${
                                    repayment.deal.dealType !== dealTypes.equity
                                        ? `| ${
                                              (repayment.deal.terms?.tenorInMonths &&
                                                  `${repayment.deal.terms?.tenorInMonths}months`) ||
                                              '-'
                                          } | ${getInterestRateRepayment(
                                              repayment.investment.amount.currency,
                                              repayment,
                                          )}`
                                        : ''
                                }`}
                            </p>
                        </div>
                        <div className="my-2" style={{ borderBottom: `1px solid lightgray` }} />
                        <div>
                            <p className="text-base" style={{ color: '#c49a6d' }}>
                                {repayment.investment.amount &&
                                    repayment.investment.amount.currency &&
                                    `${repayment.investment.amount.currency} ${
                                        repayment.investment.amount.amountUpto2dp?.toLocaleString() || 0
                                    }`}
                            </p>
                            <div className="flex items-center">
                                <label className="text-base">{repayment.investment.status}</label>
                                {showExecutedAgreements(repayment)}
                            </div>
                        </div>
                        <div className="my-2" style={{ borderBottom: `1px solid lightgray` }} />
                        <div className="flex justify-center items-center flex-col">
                            <p className="text-center w-full">
                                {checkRowOfRowPaid(repayment.repayments)} /{' '}
                                {repayment.repayments && repayment.repayments.length}
                            </p>
                            <Progress
                                showInfo={false}
                                strokeColor={{
                                    '0%': 'green',
                                    '100%': 'green',
                                }}
                                percent={
                                    (checkRowOfRowPaid(repayment.repayments) /
                                        ((repayment.repayments && repayment.repayments.length) || 0)) *
                                    100
                                }
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default InvestmentRepaymentCard;
